import { render, staticRenderFns } from "./MobileArticleFilter.component.vue?vue&type=template&id=3fdaf7f2&scoped=true"
import script from "./MobileArticleFilter.component.vue?vue&type=script&lang=ts"
export * from "./MobileArticleFilter.component.vue?vue&type=script&lang=ts"
import style0 from "./MobileArticleFilter.component.vue?vue&type=style&index=0&id=3fdaf7f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdaf7f2",
  null
  
)

export default component.exports